import { css } from "@emotion/react";

export const container = css`
  width: 100%;
`;
